<template>
  <div class="codelogin">
    <div v-if="logintype == 1">
      <!-- <div style="overflow: hidden;">
        <img src="../../assets/login/userlogin.png" alt="" @click="switchtab">
        <div class="tips_phone">验证码登录</div>
      </div> -->
      <div class="title" style="padding-top: 74px; text-align: center;">
        微信扫码登录
      </div>
      <div class="code_view">
        <qrcode ref="settype"></qrcode>
      </div>
      <div style="font-size: 15px;">
        微信扫一扫，快速观看
      </div>
    </div>
    <div v-if="logintype == 2">
      <div style="overflow: hidden;">
        <!-- <img src="../../assets/login/userlogin.png" alt="" @click="switchtab"> -->
        <!-- <div class="tips_phone">扫码登录</div> -->
        <div style="height: 50px;"></div>
      </div>
      <div class="title">
        授权登录
      </div>
      <div class="input_view">
        <div class="phone_view">
          手机号
          <input class="input_phone" v-model="tel" placeholder="请输入手机号" />
        </div>
        <div class="smscode_view">
          <input class="code_phone" v-model="icode" placeholder="请输入图形验证码" />
          <div style="border: 0;">
            <img class="codeimg" :src="codeimge" alt="" @click="clickcodeimg" />
          </div>
        </div>
        <div class="smscode_view" style="cursor: pointer;">
          <input class="code_phone" v-model="smscode" placeholder="请输入短信验证码" />
          <div v-if="count == 0" @click="sendsms">
            获取验证码
          </div>
          <div v-if="count != 0">
            重新获取{{ count }}
          </div>
        </div>

      </div>
      <el-button class="sumbit" @click="sumbit" :loading="show_login">
        登录
      </el-button>
      <div class="seach_type" @click="switchtab">
        <div class="wxlogin">
          <img src="../../assets/login/wx@2x.png" alt="" style="width: 40px;height: 40px;margin: 10px 16px;">
          <div>微信扫码登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qrcode from "./qrcode.vue"
export default {
  name: "codelogin",
  props: {},
  data() {
    return {
      logintype: "1",
      codeimge: "",
      tel: "",
      icode: "",
      numrandom: null,
      smscode: "",
      count: 0,
      time: 0,
      show_login: false,
    };
  },
  created() {

    clearInterval(this.time);
    // localStorage.setItem("room_id", this.$route.params.id);
    this.clickcodeimg();
    if (sessionStorage.getItem("smscount") > 0) {
      this.count = sessionStorage.getItem("smscount");
      this.time = setInterval(() => {
        if (this.count <= 0) {
          clearInterval(this.time);
          this.count = 0;
          return;
        }
        --this.count;
        sessionStorage.setItem("smscount", this.count);
      }, 1000);
    }
  },
  mounted() {
  },
  methods: {
    switchtab() {
      this.logintype = this.logintype == "1" ? "2" : "1";
      if (this.logintype == 2) {
        this.$refs.settype.stop_check()
      }

    },
    stop_check() {
      this.$refs.settype.stop_check()
    },
    clickcodeimg() {
      this.numrandom = Date.now() + Math.random(0, 9);
      this.codeimge = process.env.VUE_APP_BASE_API + "/login/generateValidateCode?time=" + this.numrandom;
    },
    sendsms() {
      let _this = this
      if (this.tel.length < 10 || this.icode.length < 3) {
        this.$message({
          message: "发送失败，请检查信息",
          type: "error"
        });
        return;
      }

      this.$liveapi.sendsms(this.tel, this.numrandom, this.icode).then(res => {
        if (res.data != undefined) {
          if (res.data.code === 0) {
            this.$message({
              message: "发送成功",
              type: "success"
            });
            this.count = 60;
            this.time = setInterval(() => {
              if (_this.count <= 0) {
                clearInterval(_this.time);
                _this.count = 0;
                return;
              }
              --_this.count;
              sessionStorage.setItem("smscount", _this.count);
            }, 1000);
          }
        }
        else {

        }
      })
    },
    sumbit() {
      this.show_login = true
      if (this.tel.length < 10 || this.smscode.length < 3 || this.icode.length < 3) {
        this.$message({
          message: "登陆失败，请检查信息",
          type: "error"
        });
        this.show_login = false
        return;
      }
      if (window.location.href.indexOf("/course") == -1) {
        this.$liveapi.loginforphone(this.tel, this.smscode,
          this.numrandom, this.icode, "0").then(res => {

            if (res.data.data.block) {
              this.$message({
                message: "暂无访问权限",
                type: "error"
              });
              this.show_login = false
            }
            else {
              localStorage.setItem('user_headimg', res.data.data.avatar)
              if (!res.data.data.avatar) {
                localStorage.setItem('user_headimg',
                  'https://jingyu-resource.oss-cn-shanghai.aliyuncs.com/39/IMG/2024-08-14/vc-upload-1723601501374-131723602879982.png')
              }
              let c_id = localStorage.getItem(`${this.$route.params.id}c_id`)
              localStorage.setItem("user_token_" + c_id, res.data.data.token);
              localStorage.setItem("user_phone", this.tel);
              localStorage.setItem("user_name", res.data.data.account);
              localStorage.setItem("live_nick_name", res.data.data.account);
              localStorage.setItem("bind_wxuser", JSON.stringify({
                enterpriseCode: localStorage.getItem('enterpriseCode'),
                openId: res.data.data.openId,
                unionId: res.data.data.unionId,
                subjectType: res.data.data.subjectType,
              }));
              localStorage.setItem("login_Type", "phone");
              this.$message({
                message: "登录成功",
                type: "success"
              });
              this.show_login = false
              sessionStorage.setItem("smscount", 0)
              localStorage.setItem("login_qd", 1)
              console.log("res", res)
              setTimeout(() => {
                window.location.reload()
              }, 1000);

            }
          }).catch(err => {
            console.log(err);
            this.show_login = false
          })
      }
      else {
        this.$liveapi.loginByVerificationCodeForCourse(this.tel, this.smscode,
          this.numrandom, this.icode, "0").then(res => {
            console.log("登录", res)
            if (res.data.data.block) {
              this.$message({
                message: "暂无访问权限",
                type: "error"
              });
              this.show_login = false
            }
            else {
              localStorage.setItem('user_headimg', res.data.data.avatar)
              if (!res.data.data.avatar) {
                localStorage.setItem('user_headimg',
                  'https://jingyu-resource.oss-cn-shanghai.aliyuncs.com/39/IMG/2024-08-14/vc-upload-1723601501374-131723602879982.png')
              }
              let c_id = localStorage.getItem(`${this.$route.params.id}c_id`)
              localStorage.setItem("user_token_" + c_id, res.data.data.token);
              localStorage.setItem("user_phone", this.tel);
              localStorage.setItem("user_name", res.data.data.account);
              localStorage.setItem("live_nick_name", res.data.data.account);
              localStorage.setItem("bind_wxuser", JSON.stringify({
                enterpriseCode: localStorage.getItem('enterpriseCode'),
                openId: res.data.data.openId,
                unionId: res.data.data.unionId,
                subjectType: res.data.data.subjectType,
              }));
              localStorage.setItem("login_Type", "phone");
              this.$message({
                message: "登录成功",
                type: "success"
              });
              this.show_login = false
              sessionStorage.setItem("smscount", 0)
              localStorage.setItem("login_qd", 1)
              setTimeout(() => {
                window.location.reload()
              }, 1000);
            }
          }).catch(err => {
            console.log(err);
            this.show_login = false
          })
      }
    },
  },
  components: { Qrcode }
}
</script>
<style scoped>
.codelogin {
  width: 392px;
  height: 500px;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1500);
  z-index: 2;
  border-radius: 5px;
  background-color: #fff;
}

.codelogin div:first-child div:first-child img {
  width: 74px;
  height: 74px;
  float: right;
}

.tips_phone {
  float: right;
  margin-top: 15px;
  width: 94px;
  height: 34px;
  background: url(../../assets/login/pro.png);
  background-size: 100%;
  font-size: 14px;
  text-align: center;
  line-height: 34px;
  color: #4256FB;
}

.title {
  font-size: 20px;
  font-weight: 550;
  text-align: center;
  /* text-indent: 2em; */
}

.code_view {
  width: 180px;
  height: 180px;
  background: url(../../assets/login/subtract.png);
  background-size: 100%;
  margin: 50px auto;
  padding: 20px;
}

.code_view>img {
  width: 180px;
  height: 180px;
  margin: 20px;
}

.input_view {
  width: 306px;
  margin: 25px auto;
}

.phone_view {
  padding-left: 16px;
  width: 280px;
  height: 46px;
  background: #EFF6FF;
  text-align: left;
  font-size: 14px;
  color: #555555;
  line-height: 46px;
  border-radius: 5px;
}

.input_phone {
  width: 200px;
  margin-left: 8px;
  font-size: 14px;
  padding-left: 16px;
  background-color: transparent;
  border: 0;
  outline: transparent;
  border-left: 1px solid #CEE2FF;
}

.smscode_view {
  margin-top: 24px;
  width: 296px;
  height: 46px;
  text-align: left;
  font-size: 14px;
  color: #555555;
  line-height: 56px;
  border-radius: 5px;
}

.code_phone {
  float: left;
  width: 164px;
  height: 46px;
  font-size: 14px;
  padding-left: 16px;
  background: #EFF6FF;
  border: 0;
  outline: transparent;
  border-radius: 5px;
}

.smscode_view>div {
  float: right;
  width: 110px;
  height: 46px;
  line-height: 46px;
  border-radius: 5px;
  border: 1px solid #4256FB;
  text-align: center;
  color: #4256FB;
  font-size: 14px;
}

.codeimg {
  width: 100px;
  height: 46px;
}

.sumbit {
  /* position: absolute; */
  width: 300px;
  height: 46px;
  background: #e53256;
  border-radius: 30px;
  color: #fff;
  font-size: 16px;
  margin: 15px auto;
}

.sumbit:hover {
  color: #fff;
  border-color: #e53256;
  background-color: rgba(229, 50, 86, 0.9);
}

.slide_verify {
  position: absolute;
  bottom: 160px;
  z-index: 10;
}

.seach_type {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 17px;
  width: 370px;
  margin: 0 auto;
  border-top: 2px solid #ECECEC;
}

.wxlogin {
  display: flex;
  font-size: 12px;
  text-align: center;
  flex-direction: column;
}

.wxlogin>div {
  display: inline-block;
}
</style>
